import React from 'react';

const Header = ({ onWaitlistClick }) => {
  return (
    <header className="dark-header">
      <div className="dark-logo-container">
        {/* Logo image on the left */}
        <img
          src="/AiStonkslogo.png"           // ← exact file name you uploaded
          alt="AiStonks Logo"
          className="logo-image"
        />

        {/* Text to the right of the logo */}
        <div className="brand-text">
          <h1 className="brand-logo">AiStonks</h1>
          <p className="brand-tagline">Professional investing. Simplified.</p>
        </div>
      </div>

      <nav className="dark-nav">
        <a href="#how-it-works" className="dark-nav-link">How It Works</a>
        <a href="#why-aistonks" className="dark-nav-link">Why AiStonks</a>
        <a href="#trust" className="dark-nav-link">Trust & Safety</a>
        <button onClick={onWaitlistClick} className="nav-cta-button">
          Join Waitlist
        </button>
      </nav>
    </header>
  );
};

export default Header;
